<div mat-dialog-content *ngIf="!shouldShowSpinnerOnSubmit || !isSaving; else showSpinner">
    <div class="monitoring-services-form" [class.replace-panel-step]="isReplacePanelStep" *ngIf="alulaDevice$ | async as alulaDeviceCall">
        <h2 *ngIf="!isReplacePanelStep" mat-dialog-title>
            {{ alulaDeviceCall?.result?.isMonitoringServiceEnabled() ? "Update" : "Activate" }} Monitoring Services
        </h2>
        <form [formGroup]="monitoringServicesForm" (ngSubmit)="saveForm(alulaDeviceCall)">
            <div>
                <p *ngIf="alulaDeviceCall.callState === 'loading'">Loading security device information</p>
                <div
                    *ngIf="
                        !(alarmReportingNumbers$ | async)?.length &&
                            alulaDeviceCall.callState === 'loaded' &&
                            (!alulaDeviceCall.result || alulaDeviceCall.result?.relayGroupEnabled);
                        else relayGroupAllNotEnabled
                    "
                >
                    <button
                        mat-stroked-button
                        class="redesign-incomplete-info-warning ms-activation-warning"
                        *ngIf="
                            alulaDeviceCall.callState === 'loaded' &&
                            (!alulaDeviceCall.result || !alulaDeviceCall.result.isMonitoringServiceEnabled())
                        "
                        aria-label="Activation of monitoring services may take up to 24 hours to process."
                    >
                        <img class="alert" src="assets/images/yellow-alert.svg" alt="warning icon" />
                        <span class="warning-text"
                            >Activation of monitoring services may take up to 24 hours to process. Restarting the ClareOne after you
                            activate may help expedite the process.</span
                        >
                    </button>
                    <mat-form-field appearance="outline">
                        <mat-label>Central Station</mat-label>
                        <select
                            matNativeControl
                            id="receiverGroupId"
                            required
                            formControlName="receiverGroupId"
                            [errorStateMatcher]="errorMatcher"
                        >
                            <option value="">Select a Central Station</option>
                            <option *ngFor="let group of receiverGroupSource$ | async as receivers" [value]="group.id">
                                {{ group?.name }}
                            </option>
                        </select>

                        <mat-error>
                            <span *ngIf="!receivers?.length">Please have a company admin set up a Central Station under your company</span>
                            <span *ngIf="receivers?.length && fields.receiverGroupId?.errors?.required"
                                >Please select a central station</span
                            >
                        </mat-error>
                    </mat-form-field>
                </div>
                <ng-template #relayGroupAllNotEnabled>
                    <ng-container *letVar="alarmReportingNumbers$ | async as alarmReportingNumbers">
                        <div *ngIf="alarmReportingNumbers?.length === 0; else hasAlarmReportingNumbers">
                            <p class="alert alert-warning">
                                <mat-icon>warning</mat-icon> Your company has been upgraded to use communications to Central Stations, but
                                this device has not. Would you like to upgrade it now?
                                <a (click)="upgradeToIP(alulaDeviceCall)">Upgrade</a>
                            </p>
                            <div *ngIf="fields.csPhoneNumber.value" class="readonly">
                                <p>Alarm Reporting Number</p>
                                <p>{{ fields.csPhoneNumber.value }}</p>
                            </div>
                        </div>
                    </ng-container>
                </ng-template>
                <ng-template #hasAlarmReportingNumbers>
                    <mat-form-field appearance="outline" *letVar="fields.csPhoneNumber as field">
                        <mat-label>Alarm Reporting Phone Number</mat-label>
                        <select
                            matNativeControl
                            id="csPhoneNumber"
                            formControlName="csPhoneNumber"
                            required
                            [errorStateMatcher]="errorMatcher"
                        >
                            <option value="">Select an alarm reporting number</option>
                            <option *ngFor="let station of alarmReportingNumbers$ | async" [value]="station.phone">
                                {{ station.name }} - {{ station.phone }}
                            </option>
                        </select>
                        <mat-error>
                            <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                        </mat-error>
                    </mat-form-field>
                </ng-template>

                <phone-input
                    label="Caller ID Phone Number"
                    [theForm]="monitoringServicesForm"
                    field="callerIdPhoneNumber"
                    notRequired="true"
                ></phone-input>

                <mat-form-field class="acctNumber" appearance="outline" *letVar="fields.csAccountNumber as field">
                    <mat-hint
                        >Your account number with the Central Station (CS).
                        <span> Please enter a 4-character account number. </span></mat-hint
                    >

                    <mat-label>CS Account Number</mat-label>
                    <input type="text" matInput maxlength="4" placeholder="CS Account Number" formControlName="csAccountNumber" required />
                    <mat-error>
                        <app-validation-message [touched]="field.touched" [errors]="field.errors"></app-validation-message>
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>CS Auxiliary Number</mat-label>
                    <input type="text" matInput placeholder="CS Auxiliary Number" formControlName="csAuxNumber" />
                    <mat-error>
                        <span *ngIf="fields.csAuxNumber.errors">{{ fields.csAuxNumber.errors }}</span>
                    </mat-error>
                </mat-form-field>
                <div>
                    <p>
                        <!-- leave this here because the formatting gets messed up if you remove it -->
                    </p>
                </div>
                <div
                    class="readonly"
                    *ngIf="
                        ((!isClareOne && alulaDeviceCall.result) || isClareOne) &&
                        alulaDeviceCall.callState === 'loaded' &&
                        !isReplacePanelStep
                    "
                >
                    <p>MAC Address</p>
                    <p>{{ fields.macAddress.value }}</p>
                </div>
                <mat-form-field
                    appearance="outline"
                    *ngIf="!isClareOne && !alulaDeviceCall.result && alulaDeviceCall.callState === 'loaded'"
                >
                    <mat-label>MAC Address</mat-label>
                    <input type="text" matInput placeholder="MAC Address" formControlName="macAddress" required />
                    <mat-error>
                        <span *ngIf="fields.macAddress.errors && fields.macAddress.errors.pattern"
                            >Please enter a valid and complete MAC Address.</span
                        >
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="outline"
                    *ngIf="!isClareOne && !alulaDeviceCall.result && alulaDeviceCall.callState === 'loaded'"
                >
                    <mat-label>CRC Code</mat-label>
                    <input type="text" matInput placeholder="CRC Code" formControlName="crcCode" />
                    <mat-error>
                        <span *ngIf="fields.crcCode.errors && fields.crcCode.errors.maxlength"
                            >Please enter a valid and complete CRC code.</span
                        >
                    </mat-error>
                </mat-form-field>

                <mat-form-field
                    appearance="outline"
                    *ngIf="isClareOne && !alulaDeviceCall.result && alulaDeviceCall.callState === 'loaded'"
                >
                    <mat-label>Serial Number</mat-label>
                    <input type="text" matInput placeholder="Serial Number" formControlName="serialNumber" required />
                    <mat-error>
                        <span *ngIf="fields.crcCode.errors || fields.serialNumber.errors"
                            >Please enter a valid and complete Serial Number.</span
                        >
                    </mat-error>
                </mat-form-field>

                <div class="arm-disarm-events">
                    <mat-checkbox class="long-checkbox" formControlName="openCloseSuppression" checked="true"
                        >Do not send Arm/Disarm events to CS. </mat-checkbox
                    ><span>Unchecking this box may generate higher costs with your CS.</span>
                    <mat-error>
                        <span *ngIf="fields.openCloseSuppression.errors">{{ fields.openCloseSuppression.errors }}</span>
                    </mat-error>
                </div>
            </div>
            <div class="actionBtns" align="center">
                <button
                    type="submit"
                    mat-raised-button
                    color="primary"
                    class="register new-primary-button"
                    [disabled]="!isProjectOnline || (isSubmittingForm$ | async)"
                >
                    {{ saveButtonText }}
                </button>
                <button
                    *ngIf="alulaDeviceCall?.result?.isMonitoringServiceEnabled()"
                    type="button"
                    mat-raised-button
                    color="warn"
                    (click)="disableSecurityMonitoring(alulaDeviceCall)"
                >
                    Deactivate
                </button>
            </div>
        </form>
    </div>
</div>
<ng-template #showSpinner>
    <clare-spinner text="Enabling Monitoring Services" textAlign="left"></clare-spinner>
</ng-template>
